// @flow

import React from 'react';

import { isBrowser, sendFullStoryEvent } from '@zapier/common-utils';

import ZapMenu, { type Props } from 'app/dashboard/components/ZapMenu';

type State = {
  isConfirmingDeletion: boolean,
  isMovingToFolder: boolean,
  isSharingPublicly: boolean,
};

class ZapMenuStateful extends React.Component<Props, State> {
  state = {
    isConfirmingDeletion: false,
    isMovingToFolder: false,
    isSharingPublicly: false,
  };

  onDelete = () => {
    this.setState({ isConfirmingDeletion: true });
  };

  onMove = () => {
    this.setState({ isMovingToFolder: true });
  };

  onSharePublicly = () => {
    if (isBrowser()) {
      sendFullStoryEvent('SZ Create Start');
    }
    this.setState({ isSharingPublicly: true });
  };

  render() {
    return (
      <ZapMenu
        {...this.props}
        {...this.state}
        onDelete={this.onDelete}
        onMove={this.onMove}
        onSharePublicly={this.onSharePublicly}
      />
    );
  }
}

export default ZapMenuStateful;
